document.addEventListener('DOMContentLoaded', function () {
  if (window.wishlist_io_enabled) {
    console.log("wishlist_io_enabled");
  const stockEl = document.querySelector("#stockinstore-wrapper").parentNode;
  const wishlistBtn = document.querySelector("#btn-detail-wishlist");
  if (stockEl && wishlistBtn) {
    stockEl.style.width = "83%";
    stockEl.parentNode.style.display = "flex";
    stockEl.parentNode.style.justifyContent = "space-between";
    stockEl.parentNode.style.alignItems = "center";
    wishlistBtn.style.height = "53px";
   // stockEl.insertAdjacentElement("afterend", wishlistBtn);
    wishlistBtn.style.opacity = "1";
    wishlistBtn.style.display = "flex";
  }
  } else {
    console.log("wishlist_io_disabled");
    const stockEl = document.querySelector("#stockinstore-wrapper");
    const wishlistBtn = document.querySelector("wishlist-btn");

    if (stockEl && wishlistBtn) {
      stockEl.style.width = "80%";
      stockEl.parentNode.style.display = "flex";
      stockEl.parentNode.style.justifyContent = "space-between";
      stockEl.insertAdjacentElement("afterend", wishlistBtn);
      wishlistBtn.style.opacity = "1";
      wishlistBtn.style.display = "flex";
    }
}

  const variantInputs = Array.from(document.querySelectorAll('[data-single-option-selector]'));
  console.log('variantInputs', variantInputs);
  if (!variantInputs.length) return;

  const groups = {};
  variantInputs.forEach(input => {
    const idx =
    input.dataset.index ||
    input.dataset.optionPosition ||
    input.name ||
    'option1';
    if (!groups[idx]) groups[idx] = [];
    groups[idx].push(input);
    try { input.checked = false; } catch(e){}
    input.removeAttribute && input.removeAttribute('checked');
  });
  const containerSize = document.querySelector('.size-option-infor');

  if (containerSize) {
    containerSize.innerHTML = "";
  }

  const addButtons = Array.from(document.querySelectorAll('[data-add-to-cart]'));
  addButtons.forEach(btn => {
    if (!btn.hasAttribute('disabled')) {
      btn.classList.add('needs-selection');
      btn.disabled = false;
    }
  });

  function allGroupsSelected() {
    return Object.keys(groups).every(key => groups[key].some(i => i.checked));
  }

  function clearAlerts() {
    document.querySelectorAll('.size-alert').forEach(n => n.remove());
  }

  function showSizeAlert() {
    clearAlerts();

    const container = document.querySelector('.size-option-infor');
    if (!container) return;

    const alert = document.createElement('div');
    alert.className = 'size-alert';
    alert.setAttribute('role', 'alert');
    alert.style.color = '#C36A5B';
    alert.style.fontSize = '14px';
    alert.style.textAlign = 'center';
    alert.textContent = 'Please select a size';

    container.innerHTML = '';  
    container.appendChild(alert);

    alert.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const firstUncheckedGroup = Object.keys(groups)
      .map(k => groups[k])
      .find(g => !g.some(i => i.checked));
    if (firstUncheckedGroup && firstUncheckedGroup[0]) {
      try { firstUncheckedGroup[0].focus(); } catch(e){}
    }
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', function () {
      if (allGroupsSelected()) {
        addButtons.forEach(btn => {
          btn.classList.remove('needs-selection');
        });
        clearAlerts();
      }
    });
  });

  addButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      if (!allGroupsSelected()) {
        e.preventDefault();
        e.stopPropagation();
        showSizeAlert();
        return;
      }
    });
  });
});
